import * as React from "react"
import { ResponsiveContainer, ComposedChart } from "recharts"
import cn from "@/v2-ui/utils/utils.cn"

export type ChartCompossedProps = React.ComponentProps<typeof ComposedChart>

function ChartCompossed({ className, ...props }: ChartCompossedProps) {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart className={cn("ui_chart-base", className)} {...props} />
    </ResponsiveContainer>
  )
}
export default ChartCompossed
